import { Box, Button, Stack, Typography } from "@mui/material"
import { colours } from "../../StyleConstants"
import StepperDUC from "./StepperDUC"
import { useGetDUCFileQuery } from "../../api/ducApiSlice";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserInfoQuery } from "../../api/userApiSlice";

const Review = (props: any) => {
    //@ts-ignore
    const baseUrl = window.env.baseURL.slice(0, (window.env.baseURL.length - 3))
    const [id, setID] = useState("")
    const [loading, setLoading] = useState(true)
    const { data } = useUserInfoQuery({});
    const { data: file, refetch } = useGetDUCFileQuery({ email: data['email'], id: id })
    const url2 = baseUrl + "accounts/ducprocess/redirect2"
    const [message, setMessage] = useState("")
    const navigate = useNavigate();

    useEffect(() => {
        if (props.data?.ducDetailsId) {
            setID(props.data.ducDetailsId);
        }
        if (props.data?.status === "Approved") {
            setMessage("Approved")
        } else if (props.data.status === "InProgress") {
            setMessage("In Progress")
        }
    }, [props.data])

    //Again same idea ith ID check DUCProcess and Authorized official for better explination
    useEffect(() => {
        if (id !== '') {
            refetch();
        }
    }, [id])

    //Same idea as in Authorized official once the useGetDUCFileQuery acc works
    //we set loading set to false
    useEffect(() => {
        if (file) {
            setLoading(false)
        }
    }, [file])

    const handleClickBack = () => {
        navigate("/duc")
    }

    return (
        <Stack direction="column" gap={3} height="100%">
            <Stack flexDirection="column" gap={4}>
                <StepperDUC
                    activeStep={props.curStep}
                    stepLabels={props.stepLabels}/>
            </Stack>

            <Box
                sx={{
                    alignSelf: "center",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "50px"

                }}>
                <Typography
                    textAlign="center"
                    fontWeight="600"
                    fontSize="24px"
                    color={colours.midnightBlue.blue}>
                    Request Status:
                </Typography>
                <Typography
                    color={colours.orange.orange}
                    textAlign="center"
                    fontWeight="400"
                    marginTop="-30px">
                    {message}
                </Typography>
                {props.isSub && props.data?.status !== "Approved" && <Typography
                    color={colours.orange.orange}
                    textAlign="center"
                    fontWeight="400"
                    marginTop="-30px">
                    You have been added as a sub-applicant to a PI-led Group DUC. Once approved, you will be notified.
                </Typography>}
                {!loading && <iframe title="Review DocuSign Document" src={`data:application/pdf;base64,${file.file}`}
                    width="100%" height="100%"/>}
                {loading && <iframe title="Review DocuSign Document" src={url2} width="100%" height="100%"/>}

                <Button
                    id="duc-flow-back-button"
                    variant="tertiary"
                    onClick={handleClickBack}
                    sx={{ alignSelf: "center" }}
                >
                    Back to DUC Dashboard
                </Button>
            </Box>
        </Stack>
    )
}

export default Review;